import type { Block } from '../../../../types/proposal-blocks';

type Data = Extract<Block, { type: 'image' }>;

export function ImageBlock({ block }: { block: Data }) {
  return (
    <figure className="my-6">
      <img src={block.src} alt={block.alt} className="w-full rounded-p-lg border border-proposal-border" loading="lazy" />
      {block.caption && (
        <figcaption className="mt-2 text-[12px] text-proposal-fg3 text-center font-proposal-mono">{block.caption}</figcaption>
      )}
    </figure>
  );
}
